export default "__VITE_ASSET__2f8d4124__"